// Shared chrome for the Terms and Privacy pages. Keeps the green-theme look in
// sync with Landing without duplicating nav/footer markup across both pages.
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

function Sparkle({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M12 2l1.6 6.4L20 10l-6.4 1.6L12 18l-1.6-6.4L4 10l6.4-1.6L12 2z" />
    </svg>
  );
}

export default function LegalLayout({ title, updated, children, testId }) {
  return (
    <div className="min-h-screen iti-bg-soft text-slate-900">
      <nav className="sticky top-0 z-40 backdrop-blur-md bg-white/70 border-b border-emerald-100/70">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
            <span className="iti-sparkle"><Sparkle className="w-5 h-5" /></span>
            <span className="font-display text-[17px] font-extrabold tracking-tight text-slate-900">
              Interest to Income
            </span>
          </Link>
          <Link to="/" className="iti-btn-outline px-4 py-2 text-sm font-semibold">
            Back to site
          </Link>
        </div>
      </nav>

      <article
        data-testid={testId}
        className="max-w-3xl mx-auto px-6 md:px-10 py-16"
      >
        <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.22em] text-emerald-700 uppercase">
          <Sparkles className="w-3 h-3" />
          Legal
        </div>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold mt-3 text-slate-900">
          {title}
        </h1>
        {updated && (
          <p className="text-sm text-slate-500 mt-2">Last updated: {updated}</p>
        )}

        <div className="iti-card mt-8 p-7 sm:p-10 legal-prose">
          {children}
        </div>

        <div className="text-center mt-10 text-sm text-slate-500">
          <Link to="/terms" className="hover:text-emerald-700 mx-3">Terms &amp; Conditions</Link>
          <span aria-hidden>·</span>
          <Link to="/privacy" className="hover:text-emerald-700 mx-3">Privacy Policy</Link>
          <span aria-hidden>·</span>
          <Link to="/" className="hover:text-emerald-700 mx-3">Home</Link>
        </div>
      </article>
    </div>
  );
}
